import api from 'api';

export const updateUsedMetrics = api('PUT /api/tracker/metrics/logused');

export const createCustomMetric = api('POST /api/tracker/metrics/custom');
export const loadCustomMetric = api('GET /api/tracker/metrics/custom/:id');

export const updateCustomMetric = api('PUT /api/tracker/metrics/custom/:id');
export const deleteCustomMetric = api('DELETE /api/tracker/metrics/custom/:id');
export const loadColumns = api('GET /api/tracker/columns');

export const loadChartMetricList = api('GET /api/tracker/metrics/chart/list');
export const loadCalculatorMetrics = api(
  'GET /api/tracker/calculator-metrics/metrics'
);
export const loadCohortsMetricList = api(
  'GET /api/tracker/metrics/cohorts/list'
);
export const loadMetricsAdvancedList = api(
  'GET /api/tracker/metrics/advanced/list'
);
export const loadMetricsAdvancedOperators = api(
  'GET /api/tracker/metrics/advanced/operators'
);

export const loadCohorts = api('POST /api/tracker/cohorts');

export const exportCohorts = api('POST /api/tracker/cohorts/csv', {
  responseType: 'blob',
});
export const loadMetricsChartGroups = api(
  'GET /api/tracker/metrics/chartgroups'
);
export const loadMetricsPartnersAvailability = api(
  'GET /api/tracker/metrics/partnersavailability'
);

export const exportFromGoogleDriveCohorts = api(
  'POST /api/tracker/cohorts/export-to-google-drive'
);

export const loadFavouriteMetrics = api('GET /api/tracker/metrics/favorite');
export const loadFavouriteMetricFilters = api(
  'GET /api/tracker/metrics/favorite/filters/:name'
);
